<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <!--<ul>-->
          <!--<li>-->
            <!--<a href="https://www.creative-tim.com">-->
              <!--فوتر اولی-->
            <!--</a>-->
          <!--</li>-->
          <!--<li>-->
            <!--<a href="https:///presentation.creative-tim.com">-->
              <!--فوتر دوم-->
            <!--</a>-->
          <!--</li>-->
          <!--<li>-->
            <!--<a href="https:///blog.creative-tim.com">-->
              <!--لینک داخل فوتر-->
            <!--</a>-->
          <!--</li>-->
        <!--</ul>-->
      </nav>
      <div class="copyright">
        &copy; {{ year }}, طراحی توسط
        <a href="https://badian-co.ir" target="_blank" rel="noopener">
          داده پردازی بدیعان اندیشه
        </a>
        <!--. Coded by-->
        <!--<a href="https://binarcode.com" target="_blank" rel="noopener"-->
          <!--&gt;BinarCode</a-->
        <!--&gt;-->
        <!--and-->
        <!--<a href="https://www.creative-tim.com" target="_blank" rel="noopener"-->
          <!--&gt;Creative Tim</a-->
        <!--&gt;.-->
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
